const addAnchorToURL = anchorId => {
  // console.log('addAnchorToURL', anchorId);
  if (anchorId === undefined || !anchorId) return;

  const url = new URL(window.location);
  url.hash = anchorId;
  window.history.pushState({}, '', url);
}

const scrollToElement = (name, offset = 200) => {
  const element = document.getElementById(name);
  // console.log('scrollToElement', name, element);
  if (element === undefined || !element) return false;

  const scrollElement = element.offsetTop;
  window.scrollTo({ top: scrollElement - offset, behavior: 'smooth'});
}

$('document').ready(function () {
  if (window.location.hash) {
    const element = $(window.location.hash);

    if (element.length) {
      // console.log('Anchor: ' + element.length, element);

      $(element).parent().children('.collapse--trigger').removeClass('collapsed');
      $(element).parent().children('.collapse').addClass('show');
      if (element[0] !== undefined && element[0].id) scrollToElement(element[0].id);
    }
  }
});

$('.collapse--trigger').on('click', function(e) {
  e.preventDefault();
  $anchorId = $(this).attr('href')
  $element = $($anchorId);

  if ( !$element.length ) return;
  $element.find('p:empty').remove();
  $element.slideToggle();
  addAnchorToURL($anchorId);
});